// extracted by mini-css-extract-plugin
module.exports = {"badgeListContainer":"BadgeList_badgeListContainer___J0IP","badgeWithMargin":"BadgeList_badgeWithMargin__DySZ9"};